import GetKeyFromPath from 'packages/helpers/GetKeyFromPath';

export default function BuildIconsMap(iconsContext: __WebpackModuleApi.RequireContext) {
    return iconsContext.keys().reduce((list: Record<string, Promise<string>>, path: string) => {
        list[GetKeyFromPath(path)] = iconsContext(path);
        return list;
    }, {});
}
